<template>
  <div>
    <div class="content" ref="content">
      <div class="policy-holder-title">预缴保费</div>
      <div class="money">
        <span>金额</span>
        <div>
          <valid :content="money" :validator="validator.money" ref="valid0">
            <input type="text" v-model="money" placeholder="请输入1000元至2万" @focus="trackEnterAmount" />
            <span style="padding-left: 0">元</span>
          </valid>
        </div>
      </div>
      <div class="policy-holder-title">投保人信息</div>
      <table class="policy-holder-info" cellpadding="0" cellspacing="0">
        <tr>
          <td>投保人类型</td>
          <td>
            <div :class="{ select: applicantInfoList[0].personnelType === '1', unselect: applicantInfoList[0].personnelType === '0' }" @click="changePolicyType('1')">个人</div>
            <div :class="{ select: applicantInfoList[0].personnelType === '0', unselect: applicantInfoList[0].personnelType === '1' }" @click="changePolicyType('0')" style="margin-left: 2.67vw">
              团体
            </div>
          </td>
        </tr>
        <tr>
          <td>{{ policyName }}</td>
          <td>
            <valid :content="name" :min="2" :max="100" ref="valid1">
              <input type="text" v-model="name" placeholder="请输入姓名/公司名" minlength="2" maxlength="100" @focus="trackNameInput" />
            </valid>
          </td>
        </tr>
        <tr>
          <td>{{ policyIdType }}</td>
          <td>
            <valid :content="certificateNo" :validator="validator.idNo" :max="18" ref="valid2">
              <input type="text" v-model="certificateNo" placeholder="请输入证件号" maxlength="18" @focus="trackCertificateInput" />
            </valid>
          </td>
        </tr>
        <tr>
          <td>手机号</td>
          <td>
            <valid :content="mobile" :min="11" :max="11" :validator="validator.phone" ref="valid3">
              <input type="tel" v-model="mobile" placeholder="请输入手机号" maxlength="11" @focus="trackMobileInput" />
            </valid>
          </td>
        </tr>
      </table>
      <p class="tips">*被保人信息和标的信息在每次录入货运单时填写</p>
      <div class="policy-holder-title">
        协议有效期
        <img src="../assets/question.png" class="question-img" @click.prevent.stop="showPop" />
        <div class="pop-tips" v-show="isShowPop" @click.prevent.stop>本保单首充1年，续充时可以延长保险期限，如保险期限到期有余额的，可续充金额延期或退保，续充无金额限制。</div>
      </div>
      <table class="policy-holder-info" cellpadding="0" cellspacing="0">
        <tr>
          <td>协议起期</td>
          <td style="text-align: right; line-height: 1">
            <span>预计次日生效</span>
          </td>
        </tr>
        <tr>
          <td>协议有效期</td>
          <td>1年</td>
        </tr>
      </table>
      <table class="share" cellpadding="0" cellspacing="0">
        <tr>
          <td>邀请码</td>
          <td>
            <!-- <valid
                                :content="promotionCode"
                                :max=20
                                :validator="validator.promotionCode"
                        > -->
            <input type="text" v-model="promotionCode" placeholder="邀请码(非必填)" maxlength="20" @focus="trackEnterInvitationCode" />
            <!-- </valid> -->
          </td>
        </tr>
      </table>
      <!-- <div class="notice">
                <div class="check-btn" :class="{'selected':readNotice}" @click="changeNoticeSelect"></div>
                <p>我已确认<span @click="openNotice(0)">《投保须知》</span>、<span @click="openNotice(1)">《保险条款》</span>。</p>
            </div> -->
    </div>
    <div class="loading" v-show="showLoading">
      <div class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
    </div>
    <div class="submit">
      <div class="customer" @click="callPhone">联系客服</div>
      <div class="price">￥{{ showMoney }}</div>
      <div class="submit-btn" @click="payconfirm">去提交</div>
    </div>
    <router-view></router-view>
    <customer-dialog v-show="showDialog" @confirm="confirmDialog" @cancel="cancelDialog">
      <div v-show="dialogType === 0">
        <p>您在协议期内已有保单，不能多次投保！</p>
        <p>已有保单的协议有效期：</p>
        <p>{{ policyStartDate }}至{{ policyEndDate }}</p>
      </div>
      <div v-show="dialogType === 1">
        <p>您有未支付订单，是否确认重新提交？</p>
        <p>>原订单将被取消</p>
      </div>
    </customer-dialog>
    <customer-dialog v-show="showTip" @confirm="confirmTip" @cancel="cancelTip" title="条款确认" confirmbtn="同意" :showCancel="false" :showicon="true">
      <div class="notice" style="font-size: 3.73vw; color: #111111">
        <p style="color: #333">我已阅读并同意 <span @click="openNotice(1)">《保险条款》</span><span @click="openNotice(0)">《投保须知》</span></p>
      </div>
      <div class="notice">本产品由中国平安财险保险有限公司承保<br />由天津华盛经纪保险有限公司销售</div>
    </customer-dialog>
    <!-- <legalHome v-if="showLegal" @closeLegal="closeLegal"></legalHome> -->
    <div v-if="customerServiceVisibile">
      <div class="mask"></div>
      <iframe frameborder="0" class="iframeService" :src="serviceUrl"></iframe>
    </div>
  </div>
</template>

<script>
import Valid from "./Valid";
import CustomerDialog from "./Dialog";
import { mapGetters, mapState } from "vuex";
import { formatDate, getUserInfo, showMsg, getUrlParams, setSessionObj, getSessionObj } from "../common/utils";
import { isNum, isChinese, chineseAndChar, isIdCard, getAgeByIdCard, onlyNumAndChar } from "../common/validaRule";
import { myTrack } from "../common/track";
import { wxPay } from "../common/cashierInApp";
// import legalHome from '../components/legalHome/legalHome';
const payUrl = "/hsbxjj-excellent-driving-insurance/order/insurePreOrderApplyApp";
export default {
  name: "Insure",
  components: { Valid, CustomerDialog },
  data() {
    let date = new Date();
    date.setDate(date.getDate() + 90);
    let moneyValid = (str) => {
      return isNum(str) && Number(str) >= 1000 && Number(str) <= 20000;
    };
    let nameValid = (str) => {
      if (this.applicantInfoList[0].personnelType === "1") {
        return isChinese(str);
      } else {
        return chineseAndChar(str);
      }
    };
    let idValid = (str) => {
      if (this.applicantInfoList[0].personnelType === "1") {
        return isIdCard(str) && getAgeByIdCard(str) > 17;
      } else {
        return onlyNumAndChar(str) && str.length === 18;
      }
    };
    let phoneValid = (str) => {
      return str.length === 11;
    };
    return {
      customerServiceVisibile: false,
      serviceUrl: `${window.location.origin}/hsbxjj-standard-common-insurance-page/#/customerService`,
      //校验规则
      validator: {
        name: nameValid,
        idNo: idValid,
        phone: phoneValid,
        // promotionCode:onlyNumAndChar,
        money: moneyValid,
      },
      //邀请码
      promotionCode: "",
      //协议止期
      endDate: formatDate(date, "yyyy-MM-dd"),
      //阅读条款
      readNotice: false,
      //加载效果
      showLoading: false,
      //弹窗
      showDialog: false,
      policyStartDate: "",
      policyEndDate: "",
      dialogType: -1,
      //协议有效期问号点击
      isShowPop: false,
      //是否作废之前的保单
      isConformOrderNoPay: 0,
      showTip: false,
      backtrackingCode: "",
      showLegal: false,
    };
  },
  computed: {
    ...mapGetters("policy", ["policyIdType", "policyName", "showMoney"]),
    ...mapState("policy", ["applicantInfoList", "payMoney"]),
    name: {
      get() {
        return this.applicantInfoList[0].name.replace(/[• .]/g, "·");
      },
      set(val) {
        this.$store.commit("policy/setName", val);
      },
    },
    certificateNo: {
      get() {
        return this.applicantInfoList[0].certificateNo;
      },
      set(val) {
        this.$store.commit("policy/setCertificateNo", val);
      },
    },
    mobile: {
      get() {
        return this.applicantInfoList[0].mobile;
      },
      set(val) {
        this.$store.commit("policy/setMobile", val);
      },
    },
    money: {
      get() {
        //如果显示默认值，则显示空
        if (this.payMoney.indexOf("起") > -1) {
          return "";
        } else {
          return this.payMoney;
        }
      },
      set(val) {
        this.$store.commit("policy/setMoney", val);
      },
    },
  },
  methods: {
    getCode() {
      var url = "/hsbxjj-standard-common-insurance/standardinsurance/getInvitationInfo";
      var data = {
        businessProductCode: getUrlParams().productCode,
        orderOwner: getUserInfo().mobile,
        channelId: getUrlParams().channelId,
      };
      this.$http.post(url, data).then((res) => {
        if (res.data.flag) {
          this.promotionCode = res.data.data.invitationCode;
        }
      });
    },
    // closeLegal(){
    //     this.showLegal = false;
    // },
    confirmTip() {
      this.pay();
      this.showTip = false;
    },
    payconfirm() {
      try {
        myTrack("insurance_youjiabao_info_entry_page", {
          click_submit: "点击去提交",
        });
      } catch (e) {
        window.console.log(e);
      }

      let flag = false;
      for (let i = 0; i < 4; i++) {
        if (this.$refs["valid" + i].validation()) {
          flag = true;
        }
      }
      //有校验不通过的
      if (flag) {
        return;
      }
      if (this.promotionCode && !onlyNumAndChar(this.promotionCode)) {
        showMsg("邀请码只能为数字或字母");
        return;
      }
      this.confirmTip();
      // this.showTip=true;
    },
    cancelTip() {
      this.showTip = false;
    },
    changePolicyType(type) {
      this.trackClickInsurantType(type);
      this.$store.commit("policy/setPersonType", type);
      //切换投保人类型，清空名称和证件号
      this.$store.commit("policy/setName", "");
      this.$store.commit("policy/setCertificateNo", "");
    },
    changeNoticeSelect() {
      this.readNotice = !this.readNotice;
    },
    openNotice(type) {
      if (type === 0) {
        this.$router.push({ path: "insure/InsNotice" });
      } else if (type === 1) {
        this.$router.push({ path: "insure/InsClause" });
      }
    },
    pay() {
      // if (!this.readNotice){
      //     showMsg("请阅读条款");
      //     return true;
      // }
      //暂时没想到好办法解决，
      //只能给每个valid加不同的refer

      let phone = getSessionObj("dakaUser") ? getSessionObj("dakaUser").mobile : "";
      let loginId = getSessionObj("dakaUser") ? getSessionObj("dakaUser").userId : "";
      let data = this.$store.state.policy;
      data.orderOwner = getUserInfo().mobile || phone;
      data.shareId = getUrlParams().channelId;
      data.orderOwnerId = getUserInfo().userId || loginId;
      data.backtrackingCode = this.backtrackingCode;
      data.isConformOrderNoPay = this.isConformOrderNoPay;
      setSessionObj("pageData", this.$store.state.policy);
      let url = payUrl;
      if (this.promotionCode) {
        url += "?promotionCode=" + this.promotionCode;
      }
      this.showLoading = true;
      data = encodeURIComponent(JSON.stringify(data));
      let encodeData = window.$EncryptUtils.compile(data, [{ requestContentType: 1 }, { userId: "fa929050330644e68eed7f88a6331eak" }]);
      this.$http
        .post(url, encodeData)
        .then((res) => {
          if (res.data.flag) {
            if (res.data.data.onLineInsuerance === 1) {
              sessionStorage.setItem("offLineSuccessToHome", res.data.data.returnUrl);
              this.$router.push({ path: "offLineSuccess" });
              return;
            }
            //下单成功，开始支付
            //重置一下状态，防止IOS返回不刷新
            this.isConformOrderNoPay = 0;
            let params = {};
            params.productName = "优驾保预缴保费";
            params.bxOrderNo = res.data.data.orderId;
            params.callbackUrl = res.data.data.notifyUrl;
            params.orderAmount = this.$store.state.policy.payMoney;
            if (navigator.userAgent.indexOf("daka") > -1) {
              params.fcallbackUrl = process.env.VUE_APP_CALLBACKURL;
            } else {
              params.fcallbackUrl = process.env.VUE_APP_OUTCALLBACKURL;
            }
            params.userId = getUserInfo().userId ? getUserInfo().userId : "";
            params.orderType = "8";
            if (navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1) {
              this.showLoading = false;
              //微信公众号支付
              params.payChannel = "weiXinPayGzh";
              params.productCatalog = "822";
              params.openid = getSessionObj("openId");
              this.$loading.show();
              wxPay(params, () => {
                this.$loading.hide();
              });
            } else {
              // 大卡以及站外
              location.href = process.env.VUE_APP_CASHIERURL + "?params=" + encodeURIComponent(JSON.stringify(params)) + "#/cashier";
            }
            if (!!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
              this.showLoading = false;
            }
          } else {
            this.showLoading = false;
            if (res.data.tipStatus === 5) {
              //保单重复
              this.showDialog = true;
              this.policyStartDate = res.data.data.startDate;
              this.policyEndDate = res.data.data.endDate;
              this.dialogType = 0;
            } else if (res.data.tipStatus === 7) {
              this.showDialog = true;
              this.dialogType = 1;
            } else {
              showMsg(res.data.message);
            }
          }
        })
        .catch(() => {
          showMsg("无法下单");
          // showMsg(res.data.message);
          this.showLoading = false;
        });
    },
    confirmDialog() {
      this.showDialog = false;
      if (this.dialogType === 1) {
        //需要重新提交
        this.isConformOrderNoPay = 1;
        this.pay();
      }
    },
    cancelDialog() {
      this.showDialog = false;
    },
    showPop() {
      this.isShowPop = !this.isShowPop;
    },
    callPhone() {
      this.customerServiceVisibile = true;
      try {
        myTrack("bxsc_customer_service", {
          customer_service_page: "优驾保UBI网络物责险(投保确认页)",
          product_channel: getUrlParams().orderSource ? getUrlParams().orderSource : "",
        });
      } catch (e) {}
    },

    // 输入金额埋点
    trackEnterAmount() {
      try {
        myTrack("insurance_youjiabao_info_entry_page", {
          enter_amount: "输入金额",
        });
      } catch (e) {}
    },

    // 点击投保人类型埋点
    trackClickInsurantType(type) {
      try {
        myTrack("insurance_youjiabao_info_entry_page", {
          click_insurant_type: type === "1" ? "个人" : "团体",
        });
      } catch (e) {}
    },

    // 输入投保人姓名埋点
    trackEnterInsurantName() {
      try {
        myTrack("insurance_youjiabao_info_entry_page", {
          enter_insurant_name: "输入投保人姓名",
        });
      } catch (e) {}
    },

    // 输入投保人手机号埋点
    trackEnterInsurantMobile() {
      try {
        myTrack("insurance_youjiabao_info_entry_page", {
          enter_insurant_mobile: "输入投保人手机号",
        });
      } catch (e) {}
    },

    // 输入投保人身份证号埋点
    trackEnterInsurantId() {
      try {
        myTrack("insurance_youjiabao_info_entry_page", {
          enter_insurant_id: "输入投保人身份证号",
        });
      } catch (e) {}
    },

    // 输入投保企业名称埋点
    trackEnterCompanyName() {
      try {
        myTrack("insurance_youjiabao_info_entry_page", {
          enter_company_name: "输入投保企业名称",
        });
      } catch (e) {}
    },

    // 输入投保企业信用代码埋点
    trackEnterCompanyCreditCode() {
      try {
        myTrack("insurance_youjiabao_info_entry_page", {
          enter_company_credit_code: "输入投保企业信用代码",
        });
      } catch (e) {}
    },

    // 输入投保企业手机号埋点
    trackEnterCompanyMobile() {
      try {
        myTrack("insurance_youjiabao_info_entry_page", {
          enter_company_mobile: "输入投保企业手机号",
        });
      } catch (e) {}
    },

    // 输入邀请码埋点
    trackEnterInvitationCode() {
      try {
        myTrack("insurance_youjiabao_info_entry_page", {
          enter_invitation_code: "输入邀请码",
        });
      } catch (e) {}
    },

    // 姓名输入包装方法（根据投保人类型决定调用哪个埋点）
    trackNameInput() {
      if (this.applicantInfoList[0].personnelType === "1") {
        this.trackEnterInsurantName();
      } else {
        this.trackEnterCompanyName();
      }
    },

    // 证件号输入包装方法（根据投保人类型决定调用哪个埋点）
    trackCertificateInput() {
      if (this.applicantInfoList[0].personnelType === "1") {
        this.trackEnterInsurantId();
      } else {
        this.trackEnterCompanyCreditCode();
      }
    },

    // 手机号输入包装方法（根据投保人类型决定调用哪个埋点）
    trackMobileInput() {
      if (this.applicantInfoList[0].personnelType === "1") {
        this.trackEnterInsurantMobile();
      } else {
        this.trackEnterCompanyMobile();
      }
    },
  },
  created() {
    if (getSessionObj("pageData")) {
      //有缓存数据
      let data = getSessionObj("pageData");
      this.$store.commit("policy/setApplicantInfo", data.applicantInfoList);
      this.$store.commit("policy/setMoney", data.payMoney);
    }
    this.getCode();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name != "home") {
        if (window.daka && getUrlParams().hp == 1) {
          vm.showLegal = false;
        } else {
          vm.showLegal = true;
        }
      }
    });
  },
  mounted() {
    var that = this;
    window.addEventListener(
      "message",
      function (type) {
        if (type.data.hasOwnProperty("action") && type.data.action == "closeCustomerService") {
          // 接收联系客服关闭按钮事件
          that.customerServiceVisibile = false;
        }
      },
      false
    );
    // if(this.$route.query.backtrackingCode){
    //     this.backtrackingCode = this.$route.query.backtrackingCode;
    // }
    if (this.$route.query.backtrackingCode) {
      this.backtrackingCode = this.$route.query.backtrackingCode;
    } else {
      if (window.getIseeBiz) {
        let self = this;
        window.getIseeBiz().then((res) => {
          self.backtrackingCode = res;
        });
      }
    }
    try {
      myTrack("insurance_youjiabao_info_entry_page", {
        youjiabao_info_entry_page_visit: "页面访问",
        product_channel: getUrlParams().orderSource ? getUrlParams().orderSource : "",
      });
    } catch (e) {}
    this.$refs.content.addEventListener("click", () => {
      this.isShowPop = false;
    });
  },
};
</script>

<style scoped lang="scss">
.base-table {
  width: 100%;
  background: #ffffff;

  tr {
    height: 13.33vw;
    line-height: 13.33vw;

    td {
      border-bottom: 0.27vw solid #f5f5f9;
    }

    td:nth-child(1) {
      min-width: 35vw;
      padding-left: 5.33vw;
      text-align: left;
      color: #333333;
    }

    td:nth-child(2) {
      padding-right: 5.33vw;
      text-align: right;
      color: #666666;
    }
  }
}

.basic-select {
  display: inline-block;
  width: 17.33vw;
  height: 8vw;
  margin-right: 2.67vw;
  line-height: 8vw;
  text-align: center;
  vertical-align: middle;
  border-radius: 4vw;
}

.content {
  position: absolute;
  width: 100vw;
  bottom: 14.67vw;
  top: 0;
  overflow: auto;

  .money {
    display: flex;
    width: 100vw;
    height: 13.33vw;
    justify-content: space-between;
    line-height: 13.33vw;
    background: #ffffff;

    span {
      padding-left: 5.33vw;
      text-align: left;
      color: #333333;
      vertical-align: middle;
    }

    & > div {
      padding-right: 5.33vw;
      text-align: right;
      color: #666666;
    }
  }

  .policy-holder-title {
    height: 12vw;
    padding-left: 10.67vw;
    margin-top: 2.67vw;
    line-height: 12vw;
    text-align: left;
    font-size: 4.27vw;
    font-weight: bold;
    background: url(../assets/person-b.png) no-repeat 5.33vw center #ffffff;
    background-size: 4vw;

    .question-img {
      width: 5.53vw;
      margin-left: 1.33vw;
      vertical-align: middle;
    }

    .pop-tips {
      position: absolute;
      left: 5vw;
      right: 5vw;
      padding: 2vw 4.1vw;
      line-height: 5.07vw;
      font-size: 3.8vw;
      background: #ffffff;
      color: #666666;
      word-break: break-all;
      box-shadow: 0 0 2.27vw #99c2ff40;
      z-index: 1;
    }
  }

  .policy-holder-info {
    .select {
      color: #3385ff;
      background: #dceaff;
      border: 0.27vw solid #3385ff;
      @extend .basic-select;
    }

    .unselect {
      color: #999999;
      background: #ffffff;
      border: 0.27vw solid #cccccc;
      @extend .basic-select;
    }

    @extend .base-table;
  }

  .tips {
    padding-left: 5.33vw;
    text-align: left;
    font-size: 3.2vw;
    line-height: 12vw;
    color: #999999;
  }

  .share {
    margin-top: 2.67vw;
    @extend .base-table;
  }

  .common-select {
    padding-right: 4.56vw;
    background: url(../assets/down.png) no-repeat right center;
    background-size: 2.67vw;
  }

  .notice {
    display: flex;
    padding: 2vw 0vw;
    font-size: 3.2vw;
    text-align: left;
    color: #999;

    .check-btn {
      width: 5.33vw;
      height: 5vw;
      background: url("../assets/uncheck.png") no-repeat center;
      background-size: 3.2vw;
    }

    .selected {
      background: url("../assets/checked.png") no-repeat center;
      background-size: 3.2vw;
    }

    p {
      width: 87vw;
      line-height: 5vw;

      span {
        color: #3385ff;
      }
    }
  }
}

.submit {
  position: absolute;
  display: flex;
  bottom: 0;
  height: 14.67vw;

  .customer {
    width: 15.73vw;
    padding-top: 8.67vw;
    border-right: 0.27vw solid #dddddd;
    font-size: 2.93vw;
    color: #333333;
    background: url("../assets/customer.png") no-repeat center 2.67vw #ffffff;
    background-size: 5.33vw;
    vertical-align: middle;
    text-decoration: none;
  }

  .price {
    width: 42vw;
    height: 14.67vw;
    line-height: 14.67vw;
    text-align: center;
    font-size: 4.8vw;
    color: #ff9000;
    background: #ffffff;
    vertical-align: middle;
  }

  .submit-btn {
    width: 42vw;
    height: 14.67vw;
    line-height: 14.67vw;
    text-align: center;
    font-size: 4.56vw;
    color: #ffffff;
    background: #3385ff;
    vertical-align: middle;
  }
}
</style>
